import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { CONFIG } from "@/lib/data";

export const WhatsAppFab = () => {
  const href = `https://wa.me/${CONFIG.whatsapp}?text=${encodeURIComponent(CONFIG.whatsappMsg)}`;
  return (
    <motion.a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Chat on WhatsApp"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.6, type: "spring", stiffness: 200 }}
      whileHover={{ scale: 1.08 }}
      className="fixed bottom-6 right-6 z-40 grid h-14 w-14 place-items-center rounded-full btn-accent animate-pulse-glow"
    >
      <MessageCircle size={26} />
    </motion.a>
  );
};
